import { isValidObject, SuperDate } from '@razlet/utils';

export default class Accreditation {
  #data = null;

  #q = {};

  constructor (data) {
    if (!isValidObject(data)) return;

    this.#data = data;

    if (isValidObject(data.data)) this.#q = data.data;
  }

  get id () {
    return this.#data.id;
  }

  get createdAt () {
    return new SuperDate(this.#data.createdAt);
  }

  get createdBy () {
    return this.#data.createdBy;
  }

  get isResident () {
    return this.#data.isResident;
  }

  get status () {
    return this.#data.status;
  }

  get comment () {
    return this.#data.comment;
  }

  get statusForShipper () {
    return this.status === 'updated' || this.status === 'new' ? 'progress' : this.status;
  }

  get isNew () {
    return this.status === 'new';
  }

  get isUpdated () {
    return this.status === 'updated';
  }

  get isRejected () {
    return this.status === 'rejected';
  }

  get isApproved () {
    return this.status === 'confirmed';
  }

  get isCompleted () {
    return this.status === 'completed';
  }

  /* COMPANY INFO */
  get fullNameRu () {
    return this.#q.contractorName;
  }

  get fullNameEn () {
    return this.#q.englishFullName;
  }

  get shortNameEn () {
    return this.#q.englishShortName;
  }

  get inn () {
    return this.#q.inn;
  }

  get kpp () {
    return this.#q.kpp;
  }

  get ogrn () {
    return this.#q.ogrn;
  }

  get contactPhone () {
    return this.#q.declarantPhone;
  }

  get legalAddress () {
    return this.#q.registrationAddress;
  }

  get postalAddress () {
    return this.#q.physicalAddress;
  }

  get faxNumber () {
    return this.#q.fax;
  }

  get additionalPhone () {
    return this.#q.contactPhone;
  }

  get okved () {
    return this.#q.okved;
  }

  get okpo () {
    return this.#q.okpo;
  }

  get ceoFullName () {
    return this.#q.directorFullName;
  }

  get ceoPhone () {
    return this.#q.directorPhone;
  }

  get accountantFullName () {
    return this.#q.accountantFullName;
  }

  get accountantPhone () {
    return this.#q.accountantPhone;
  }

  get bankAccountCurrency () {
    return this.#q.currency;
  }

  get bankAccountNumber () {
    return this.#q.account;
  }

  get bankAccountType () {
    return this.#q.accountType;
  }

  get bankCorrespondentAccountNumber () {
    return this.#q.correspondentAccount;
  }

  get bankCity () {
    return this.#q.bankCity;
  }

  get bankName () {
    return this.#q.bankName;
  }

  get bankBik () {
    return this.#q.bik;
  }

  get bankFundsRecipient () {
    return this.#q.moneyRecipient;
  }

  get abilityProps () {
    return {};
  }
};
